import { CountryWeightApiDto } from '@lx/shared/api';

export type CountryWeight = CountryWeightApiDto;
